import { useSignal } from "@preact/signals-react"
import { BIChartData, BIChartLegendVisibility } from "Pages/BusinessLogistics/BI/Page/@signals"

export default function useBiChartVisibility() {

	const isVisible = useSignal(true)

	const setIsVisible = () => {
		if (isVisible.value || !!BIChartLegendVisibility.value.length) {
			BIChartLegendVisibility.value = []
			isVisible.value = false
		} else {
			BIChartLegendVisibility.value = BIChartData.value.keySeries.map(({ dataKey }) => dataKey)
			isVisible.value = true
		}
	}

	const onLegendClick = e => {
		const value = e.target.dataItem._settings.name
		const idx = BIChartLegendVisibility.value.findIndex(name => name === value)

		if (idx !== -1) {
			BIChartLegendVisibility.value.splice(idx, 1)
		} else {
			BIChartLegendVisibility.value.push(value)
		}
	}


	return {
		setIsVisible,
		onLegendClick,
	}
}